var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bg"},[_c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"top-header"},[_c('ul',{staticClass:"zyz-t1"}),_vm._v(" "),_c('en-logo'),_vm._v(" "),_c('en-search'),_vm._v(" "),_c('en-settleup')],1),_vm._v(" "),_c('en-nav')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537a42c0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 